<div [class.open]="!(isNavBarCollapsed | async)" id="header-navbar-wrapper">
  <ds-themed-header></ds-themed-header>
</div>
